import React, { useContext } from 'react'

import { Link } from 'react-router-dom'
import useStructureParams from '../lib/useStructureParams'
import { filterAndSortChildren, wardNamesCleanup } from '../lib/structures'
import { useCrunchWeek } from '../data/useCrunchWeekCanvassing'

import PageTitle from './PageTitle'
import Breadcrumbs from './Breadcrumbs'
import PageHeader from './PageHeader'
import ViewButtons from './ViewButtons'
import ResponsiblePersons from './ResponsiblePersons'

import Table from 'react-bootstrap/Table'
import { Col, Row } from 'react-bootstrap'

import { LoadingSpinner } from './spinners'
//import { NoAssignedWardsMessage } from './alerts'

import {
    Chart as ChartJS,
    registerables,
    TooltipItem
} from 'chart.js'
import 'chartjs-adapter-date-fns'
import { Line } from 'react-chartjs-2';
import annotationPlugin from 'chartjs-plugin-annotation'
//import ChartDataLabels from 'chartjs-plugin-datalabels'


import moment from 'moment';

//import VDCategoryFilter from './VDCategoryFilter'
import { DashboardContext } from '../data/context'

import { statsStyle, formatInt, formatPerc } from '../lib/utils'

import HeaderLayout from "./HeaderLayout";

//import Form from "react-bootstrap/Form";

ChartJS.register(annotationPlugin, ...registerables)

export default function CrunchWeekView(): JSX.Element {
    const { filterLabel } = useContext(DashboardContext)
    // get parameters from the URL
    const { code, type } = useStructureParams()

    // get stats from the GraphQL API
    const { stats, loading } = useCrunchWeek({ type, code, filterLabel })
    console.log("[crunch week stats]", stats);

    // this happens while the query is still fetching
    if (stats == null || loading) {
        return <LoadingSpinner />
    }
    console.log("[crunch week test]", filterAndSortChildren(stats.type, stats.children));
    // filter/sort children appropriately according to structure type
    const children = filterAndSortChildren(stats.type, stats.children)
        .map(wardNamesCleanup)
        .filter(c => c.structureHasAssignedWards)
      .sort((a, b) => {
          return (b.crunchWeekCanvassing?.tags?.unique_campaign / b.crunchWeekCanvassing.tags.target ) - (a.crunchWeekCanvassing?.tags?.unique_campaign / a.crunchWeekCanvassing.tags.target)
      }) 

      console.log("[crunch week children]", children);
    const historicRollLine = stats.crunchWeekCanvassing.history.map(datum => ({ x: moment(datum.date).format('ddd, DD MMM'), y: datum.count }));
    const milestones = stats.crunchWeekCanvassing.milestones.map(datum => ({ x: moment(datum.date).format('ddd, DD MMM'), y: datum.count }));
    // const dailyRoll = stats.crunchWeekCanvassing.daily.map(datum => ({ x: moment(datum.date).format('ddd, DD MMM'), y: datum.count }));
    const dailyCampaignRoll = stats.crunchWeekCanvassing.dailyCampaign.map(datum => ({ x: moment(datum.date).format('ddd, DD MMM'), y: datum.count }));
    // const fakePlaceholderBar = stats.crunchWeekCanvassing.dailyCampaign.map(datum => ({ x: moment(datum.date).format('ddd, DD MMM'), y: 0 }));

    // const timelineDate = stats.crunchWeekCanvassing.milestones.map(datum => ({ x: moment(datum.date).format('ddd, DD MMM'), y: null }))


    const graphData = {
        datasets: [
            {
                label: 'Unique Canvasses',
                data: historicRollLine,
                borderColor: '#4D77FF'
            },
            {
                label: 'Unique Canvass Milestone',
                data: milestones,
                borderColor: '#56BBF1',
                borderDash: [2, 2],
                pointRadius: 0,
             
            }, 
            // {
            //     label: 'Daily Unique Campaign Canvasses Test',
            //     type: "bar",
            //     data: fakePlaceholderBar,
            //     backgroundColor: "transparent",
            //     barThickness: 30,
            //     display: false
  
            // } ,    
            // {
            //     label: 'Daily Unique Canvasses',
            //     type: "bar",
            //     data: dailyRoll,
            //     backgroundColor: "#bbc4c9",
            //     barThickness: 30
                
            // },
            {
                label: 'Daily Unique Campaign Canvasses',
                type: "bar",
                data: dailyCampaignRoll,
                backgroundColor: "#B9D9EB",
                barThickness: 30
                
            }     
        ]
    }

    const targetAnnotations = {
        target: {
            type: 'line',
            yMin: stats.crunchWeekCanvassing.tags.target,
            yMax: stats.crunchWeekCanvassing.tags.target,
            borderColor: 'rgb(255, 99, 132)',
            borderWidth: 2,
            label: {
                enabled: true,
                content: 'Target'
            }
        }
    }

    const graphOptions = {
        interaction: {
            intersect: false,
            mode: 'index'
        },

        animation: false,
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: true
            },
            xLine: {
                offset: false,
                display: false
            },
            xBar: {
                offset: false
            }
        },
        plugins: {
            legend: {
                //position: 'bottom' as const,
                display: false
            },
            autocolors: false,
            annotation: {
                annotations: targetAnnotations
            },
            tooltip: {
                filter: (tooltipItem: TooltipItem<'bar' | 'line'>) => tooltipItem.datasetIndex !== 2
            },
            title: {
                display: true,
                text: 'Crunch Week',
                font: {
                    size: 18,
                }
            }
        }
    }

    if (!stats.structureHasAssignedWards) {
        return (
            <>
                <PageTitle title={stats.name} />
                <Breadcrumbs structure={stats} suffix='/crunchweek' />
                <HeaderLayout
                  element1={<PageHeader structure={stats} />}
                  element2={<ViewButtons structure={stats} section="crunchweek" />}
                />
            </>
        )
    } else {
        return (
            <>
                <PageTitle title={stats.name} />
                <Breadcrumbs structure={stats} suffix='/crunchweek' />
                {/* <PageHeader structure={stats} /> */}
                {/* <VDCategoryFilter counts={stats.counts} /> */}
                <HeaderLayout
                  element1={<PageHeader structure={stats} />}
                  element2={<ViewButtons structure={stats} section="crunchweek" />}
                />


                {/* <Row>
                  <Col md={12}>
                    <div
                     style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "space-between",
                     }}
                    >
                     <span></span>
                     <div style={{ display: "flex", alignItems: "center" }}>
                     <Button
                       style={{ margin: "0 15px 5px 0" }}
                       className="ag-ri-reset-btn"
                       onClick={() => refreshData()}
                     >
                     </Button>
                     <Form.Switch
                       type="switch"
                       label="Auto refresh"
                       id="custom-switch"
                       checked={autoRefresh}
                       onChange={handleAutoRefresh}
                     />
                     </div>
                    </div>
                   </Col>
		</Row> */}

                <Row style={{ marginBottom: 15 }}>
                    <Col md={12}>
                        <div style={{ position: 'relative', height: '400px', width: '100%' }}>
                            {/* @ts-expect-error */}
                            <Line options={graphOptions} data={graphData} />
                        </div>
                    </Col>
                </Row>

                <Table responsive striped bordered size='sm' className='break-before stats'>
                    <thead>
   <tr>
                            <th className='text-center'>&nbsp;</th>                            
                            <th className='text-center'>A</th>
                            {/* <th style={{backgroundColor: 'lightgrey'}} className='text-center'>B</th> */}
                            <th style={{backgroundColor: 'lightblue'}} className='text-center'>B</th>
                            <th className='text-center'>C = A &minus; B</th>
                            <th className='text-center'>D = C / A</th>
                            <th className='text-center'>E</th>
                            <th className='text-center'>F = E / B</th>
                            <th className='text-center' style={{ minWidth: 140 }}>G</th>
                            <th className='text-center' style={{ minWidth: 140 }}>H = B / G</th>
                            <th className='text-center'>I</th>     


                        </tr>                        
                        <tr>
                            <th className='text-center'>Structure</th>                            
                            <th className='text-center'>All Canvasses done during Crunch Week</th>
                            {/* <th style={{backgroundColor: 'lightgrey'}} className='text-center'>Unique Canvasses done during Crunch Week</th> */}
                            <th style={{backgroundColor: 'lightblue'}} className='text-center'>Increase this Week in Unique Canvasses since 1 June 2024 </th>
                            <th className='text-center'>Number of Canvasses done during Crunch Week of voters that were already Canvassed in the campaign </th>
                            <th className='text-center'>% of Canvasses who were canvassed during Crunch Week that were already Canvassed in the campaign</th>
                            <th className='text-center'>Unregistered Voters who were Uniquely Canvassed during Crunch Week</th>
                            <th className='text-center'>% of Unregistered Voters who were Uniquely Canvassed during Crunch Week</th>
                            <th className='text-center'>Crunch Week Goal</th>
                            <th className='text-center'>% of Crunch Week Goal Met</th>
                            <th className='text-center'>% Contribution to Overall Unique Canvass Goal</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        {children.map((c: any) => (
                            <tr key={c.code}>
                                {stats.type !== 'ward' ?
                                    <td><Link to={`/${c.type}/${c.code}/crunchweek`}>{c.name}</Link> <ResponsiblePersons persons={c.responsiblePersons} /></td>
                                    : <td>{c.name}</td>
                                }

                                <td className='text-center'>{formatInt(c.crunchWeekCanvassing.tags.all)}</td>
                                {/* <td style={{backgroundColor: 'lightgrey'}}className='text-center'>{formatInt(c.crunchWeekCanvassing.tags.unique)}</td> */}
                                <td style={{backgroundColor: 'lightblue'}}className='text-center'>{formatInt(c.crunchWeekCanvassing.tags.unique_campaign)}</td>
                                <td className='text-center'>{formatInt(c.crunchWeekCanvassing.tags.all - c.crunchWeekCanvassing.tags.unique_campaign)}</td>
                                <td className='text-center'>{formatPerc((c.crunchWeekCanvassing.tags.all - c.crunchWeekCanvassing.tags.unique_campaign)/ c.crunchWeekCanvassing.tags.all)}</td>
                                <td className='text-center'>{formatInt(c.crunchWeekCanvassing.tags.unregistered)}</td>
                                <td className='text-center'>{formatPerc(c.crunchWeekCanvassing.tags.unregistered / c.crunchWeekCanvassing.tags.unique_campaign)}</td>
                                <td className='text-center'>{formatInt(c.crunchWeekCanvassing.tags.target)}</td>
                                <td style={statsStyle(c.crunchWeekCanvassing.tags.unique_campaign, c.crunchWeekCanvassing.tags.target)} className='text-center'>
                                    {formatPerc(c.crunchWeekCanvassing.tags.unique_campaign / c.crunchWeekCanvassing.tags.target)}</td>
                                <td className='text-center'>{formatPerc(c.crunchWeekCanvassing.tags.unique_campaign / c.crunchWeekCanvassing.tags.total_target)}</td>                                      
                              
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr className='font-weight-bold'>
                            <td className='text-center'>Total</td>

                            <td className='text-center'>{formatInt(stats.crunchWeekCanvassing.tags.all)}</td>
                            {/* <td style={{backgroundColor: 'lightgrey'}}className='text-center'>{formatInt(stats.crunchWeekCanvassing.tags.unique)}</td> */}
                            <td style={{backgroundColor: 'lightblue'}}className='text-center'>{formatInt(stats.crunchWeekCanvassing.tags.unique_campaign)}</td>
                            <td className='text-center'>{formatInt(stats.crunchWeekCanvassing.tags.all - stats.crunchWeekCanvassing.tags.unique_campaign)}</td>
                            <td className='text-center'>{formatPerc((stats.crunchWeekCanvassing.tags.all - stats.crunchWeekCanvassing.tags.unique_campaign) / stats.crunchWeekCanvassing.tags.all)}</td>
                            <td className='text-center'>{formatInt(stats.crunchWeekCanvassing.tags.unregistered)}</td>
                            <td className='text-center'>{formatPerc(stats.crunchWeekCanvassing.tags.unregistered / stats.crunchWeekCanvassing.tags.all)}</td>
                            <td className='text-center'>{formatInt(stats.crunchWeekCanvassing.tags.target)}</td>
                            <td style={statsStyle(stats.crunchWeekCanvassing.tags.unique_campaign, stats.crunchWeekCanvassing.tags.target)} className='text-center'>
                                {formatPerc(stats.crunchWeekCanvassing.tags.unique_campaign / stats.crunchWeekCanvassing.tags.target)}</td>
                            <td className='text-center'>{formatPerc(stats.crunchWeekCanvassing.tags.unique_campaign / stats.crunchWeekCanvassing.tags.total_target)}</td>                                
                    
                        </tr>
                    </tfoot>
                </Table>
            </>
        )
    }
}
